type SeoProps = {
    title?: string
    sideName?: string
    description?: string
    image?: {
        src: string
        width: number
        height: number
    }
    keywords?: string
}

const seo = ({title, sideName = 'Gravity Shirts', description, keywords, image}: SeoProps) => [
    {title: title ? `${title} | ${sideName}` : sideName},
    {name: 'description', content: description},
    {name: 'keywords', content: keywords},
    {name: 'twitter:title', content: title},
    {name: 'twitter:description', content: description},
    {property: 'og:type', content: 'website'},
    {property: 'og:title', content: title},
    {property: 'og:description', content: description},
    {property: 'og:locale', content: 'en_GB'},
    ...(image
        ? [
              {name: 'twitter:image', content: image.src},
              {name: 'twitter:card', content: 'summary_large_image'},
              {property: 'og:image', content: image.src},
              {property: 'og:image:width', content: String(image.width)},
              {property: 'og:image:height', content: String(image.height)},
          ]
        : []),
    ...(sideName ? [{property: 'og:site_name', content: sideName}] : []),
]

export default seo
